import React from 'react';
import ProjectUtils from '../../helper/ProjectUtils';
import SubTitleUtils from '../../helper/SubTitleUtils';
import TimeUtils from '../../helper/TimeUtils';
import StyleCheckResultList from '../drogable/FindResult/StyleCheckResultList';
import ExportView from './ExportView';

const ExportViewWrap = ({ _WaveformView }) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        // width: '490px',
        height: '500px',
        overflow: 'scroll',
        padding: '1rem',
      }}
    >
      {_WaveformView.isEnableStyleCheck === true ? (
        <StyleCheckResultList _WaveformView={_WaveformView} />
      ) : null}

      <ExportView
        DataObjArray={_WaveformView.DataObjArray}
        downloadTxtFile={async (qtype) => {
          let type = qtype;

          let data = _WaveformView.DataObjArray.getContent();

          data = TimeUtils.InTimecodeOutTimecodeCheck(data);

          let parser_fileString = '';
          if (type === 'srt') {
            parser_fileString = SubTitleUtils.getExportSRT_DataObject(data);
          }
          if (type === 'vtt') {
            parser_fileString = SubTitleUtils.getExport_VTT_DataObject(data);
          }
          if (type === 'smi') {
            parser_fileString = SubTitleUtils.getExport_SMI_DataObject(data);
          }
          if (type === 'ttml') {
            parser_fileString = SubTitleUtils.getExport_TTML_DataObject(data);
          }
          if (type === 'xml_Flash') {
            parser_fileString =
              SubTitleUtils.getExport_XML_Flash_DataObject(data);
            type = 'xml';
          }
          if (type === 'xml_Time') {
            parser_fileString =
              SubTitleUtils.getExport_XML_Time_DataObject(data);
            type = 'xml';
          }
          if (type === 'dfxp') {
            parser_fileString = SubTitleUtils.getExport_DFXP_DataObject(data);
            type = 'dfxp';
          }

          if (type === 'sub') {
            parser_fileString =
              SubTitleUtils.getExport_MicroDVD_SUB_DataObject(data);
          }
          if (type === 'sbv') {
            parser_fileString = SubTitleUtils.getExport_SBV_DataObject(data);
          }
          if (type === 'ssa') {
            parser_fileString = SubTitleUtils.getExport_SSA_DataObject(data);
          }

          await _WaveformView.setState({ JsonData: parser_fileString });

          //取得本地資料

          //Document下載
          document.getElementById('myInput').value = parser_fileString;
          //轉換下載
          var blob = new Blob([parser_fileString], {
            type: 'text/plain;charset=utf-8',
          });
          // var blob = new Blob( [ fileString ], {
          //     type: 'application/json'
          // });
          var url = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute(
            'download',
            `${ProjectUtils.getEditingProjectTitle()}.${type}`
          );
          var event = document.createEvent('MouseEvents');
          event.initMouseEvent(
            'click',
            true,
            true,
            window,
            1,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          link.dispatchEvent(event);
        }}
        downloadSource={() => {
          //專案標題
          let fProjectTitle = ProjectUtils.getProjectTitle(
            parseInt(_WaveformView.props.match.params.tIndex, 10)
          );

          var str = JSON.stringify(_WaveformView.DataObjArray.getContent());
          // var data = this.encode( str );

          var blob = new Blob([str], {
            type: 'text/plain;charset=utf-8',
          });

          var url = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', `${fProjectTitle}_source.txt`);
          var event = document.createEvent('MouseEvents');
          event.initMouseEvent(
            'click',
            true,
            true,
            window,
            1,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          link.dispatchEvent(event);

          // this.setState({
          //   isShowExportView: false,
          //   isShowTranslationsNavbarAlert: false,
          // });
        }}
        closeExportView={() => {
          _WaveformView.setState({ isShowExportView: false });
        }}
      />
    </div>
  );
};
export default ExportViewWrap;



// WEBPACK FOOTER //
// ./src/components/import/ExportViewWrap.js